import { render, staticRenderFns } from "./DepartPostList.vue?vue&type=template&id=f5180cf2&scoped=true&"
import script from "./DepartPostList.vue?vue&type=script&lang=js&"
export * from "./DepartPostList.vue?vue&type=script&lang=js&"
import style0 from "./DepartPostList.vue?vue&type=style&index=0&id=f5180cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5180cf2",
  null
  
)

export default component.exports